import React, {useEffect, useState} from 'react'
import _ from 'lodash';
import ShowTabsList from "../../../common/ui/show-tabs-list";
import {
    DEFAULT_EDITOR_SETTING_TAB, DEFAULT_EDITOR_TEXT_TAB,
    EDITOR_SETTING_TABS_LIST, EDITOR_TEXT_TABS_LIST
} from "../../constants/design.constant";
import ImageSidebarSection from "../../../image/image-sidebar/image-sidebar-section";
import SelectTags from "../../../tag/select-tags";
import DimensionDetail from "./settings/dimension-detail";
import DisplayTextDetail from "./settings/display-text-detail";
import {
    prepareSelectedSize,
    processDisplayTextDetail,
    processTextItemsLayer,
    setSettingsToTextItems
} from "../../utils/design-variant-util";
import DesignVariantLayers from "./layers/design-variant-layers";
import EditFontDetails from "./settings/edit-font-details";
import EditColorDetails from "./settings/edit-color-details";
import {processColorDetails} from "../../../common/utils/color-util";
import EditStrokeDetails from "./settings/edit-stroke-details";
import EditShadowDetails from "./settings/edit-shadow-details";
import EditBackgroundColorDetails from "./settings/edit-background-color-details";
import Shapes from "./shapes/shapes";
import SelectColorTypeDetails from "./settings/select-color-type-details";

const tabsList = EDITOR_SETTING_TABS_LIST;

const EditorSettings = ({
                            allTags,
                            parentProduct,
                            designVariantDetail,
                            designDetail,
                            setDesignVariantDetail,
                            setSelectedImage,
                        }) => {
    const [selectedTab, setSelectedTab] = useState(DEFAULT_EDITOR_SETTING_TAB);
    const [selectedTags, setSelectedTags] = useState([]);

    const handleSelectTagsChanges = (event) => {
        const {name, value} = event.target;
        setSelectedTags(value);
    }

    const handleDesignVariantTagChanges = async (event) => {
        const {name, value} = event.target;
        const existingDesignVariantDetail = {...designVariantDetail};
        existingDesignVariantDetail[name] = value;

        if (name === 'tagList') {
            const allTags = {};
            _.forEach(value, tagId => {
                allTags[tagId] = true;
            });

            existingDesignVariantDetail['tags'] = allTags;
            existingDesignVariantDetail['tagList'] = value;
        }

        setDesignVariantDetail(existingDesignVariantDetail);
    }

    const handleSettingsChanges = (event) => {
        const {name, value, type} = event.target;
        const existingDesignVariantDetail = {...designVariantDetail};

        if (type === 'checkbox') {
            existingDesignVariantDetail.settings[name] = !existingDesignVariantDetail.settings[name];
        } else {
            existingDesignVariantDetail.settings[name] = value;
        }

        if (name === 'displayText') {
            processDisplayTextDetail(existingDesignVariantDetail.settings);
            processTextItemsLayer(existingDesignVariantDetail);
        } else if (name === 'halfWidthDesign') {
            const selectedSize = prepareSelectedSize(existingDesignVariantDetail, parentProduct, designDetail);

            if (existingDesignVariantDetail.settings[name]) {
                existingDesignVariantDetail.settings.width = _.parseInt(String(selectedSize.widthPixel / 2));
            } else {
                existingDesignVariantDetail.settings.width = selectedSize.widthPixel;
            }
        } else if (name === 'size') {
            const sizeMap = _.keyBy(parentProduct?.sizes, 'name');
            const selectedSize = sizeMap[value];
            existingDesignVariantDetail.settings.width = selectedSize.widthPixel || existingDesignVariantDetail.settings.width;
            existingDesignVariantDetail.settings.height = selectedSize.heightPixel || existingDesignVariantDetail.settings.height;
        } else {
            if (name === 'colorKey' || name === 'colorCodeKey' ||
                name === 'strokeColorKey' || name === 'strokeColorCodeKey' ||
                name === 'shadowColorKey' || name === 'shadowColorCodeKey' ||
                name === 'backgroundColorKey' || name === 'backgroundColorCodeKey') {
                processColorDetails(existingDesignVariantDetail.settings);
            }

            setSettingsToTextItems(existingDesignVariantDetail, name, type);
        }

        setDesignVariantDetail(existingDesignVariantDetail);
    }

    const handleClearColorInSettings = (attributeList) => {
        const existingDesignVariantDetail = {...designVariantDetail};

        _.forEach(attributeList, attribute => {
            existingDesignVariantDetail.settings[attribute] = '';
        });

        if (attributeList.indexOf('color') !== -1) {
            existingDesignVariantDetail.settings['fill'] = '';
            setSettingsToTextItems(existingDesignVariantDetail, 'fill', 'text');
        }

        setDesignVariantDetail(existingDesignVariantDetail);
    }

    return (
        <>
            <div className="w-full mr-2 design-editor-container -ml-4">
                <div>
                    <ShowTabsList
                        setSelectedTab={setSelectedTab}
                        selectedTab={selectedTab}
                        tabsList={tabsList}/>
                </div>

                <div className="mt-4">

                    {selectedTab?.key === 'settings' && designVariantDetail?.settings &&
                        <div
                            className="design-variant-settings-container overflow-y-scroll px-2 bg-gray-100 rounded border border-gray-300">

                            <div className="mt-4 pb-10">
                                <DimensionDetail
                                    parentProduct={parentProduct}
                                    settings={designVariantDetail?.settings}
                                    handleSettingsChanges={handleSettingsChanges}/>

                                <DisplayTextDetail
                                    settings={designVariantDetail?.settings}
                                    handleSettingsChanges={handleSettingsChanges}/>

                                {!designVariantDetail?.settings?.noText &&

                                    <>
                                        <EditFontDetails
                                            displayTextItem={designVariantDetail?.settings}
                                            handleFontDetailsChanges={handleSettingsChanges}/>

                                        <SelectColorTypeDetails
                                            label={'Text Color & Shade'}
                                            parentForm={designVariantDetail?.settings}
                                            colorAttribute={undefined}
                                            colorKeyAttribute={'colorKey'}
                                            colorCodeKeyAttribute={'colorCodeKey'}
                                            settings={designVariantDetail?.settings}
                                            handleColorDetailsChanges={handleSettingsChanges}
                                            handleClearColorDetailsChanges={handleClearColorInSettings}/>

                                        {/*<EditColorDetails
                                            displayTextItem={designVariantDetail?.settings}
                                            handleColorDetailsChanges={handleSettingsChanges}
                                            handleClearColor={undefined}/>*/}

                                        <EditStrokeDetails
                                            parentForm={designVariantDetail?.settings}
                                            handleStrokeDetailsChanges={handleSettingsChanges}/>

                                        <EditShadowDetails
                                            parentForm={designVariantDetail?.settings}
                                            handleShadowDetailsChanges={handleSettingsChanges}/>
                                    </>

                                }

                                <SelectColorTypeDetails
                                    label={'Background Color & Shade'}
                                    parentForm={designVariantDetail?.settings?.background}
                                    colorAttribute={'background'}
                                    colorKeyAttribute={'backgroundColorKey'}
                                    colorCodeKeyAttribute={'backgroundColorCodeKey'}
                                    settings={designVariantDetail?.settings}
                                    handleColorDetailsChanges={handleSettingsChanges}
                                    handleClearColorDetailsChanges={handleClearColorInSettings}/>

                                {/*<EditBackgroundColorDetails
                                    parentForm={designVariantDetail}
                                    setParentForm={setDesignVariantDetail}
                                    handleBackgroundColorDetailsChanges={handleSettingsChanges}/>*/}
                            </div>

                        </div>
                    }


                    {selectedTab?.key === 'layers' &&
                        <div className="design-editor-image-sidebar-container overflow-y-scroll">
                            <DesignVariantLayers
                                designVariantDetail={designVariantDetail}
                                setDesignVariantDetail={setDesignVariantDetail}/>
                        </div>
                    }

                    {selectedTab?.key === 'shapes' &&
                        <div className="design-editor-image-sidebar-container overflow-y-scroll">
                            <Shapes
                                designVariantDetail={designVariantDetail}
                                setDesignVariantDetail={setDesignVariantDetail}/>
                        </div>
                    }

                    {selectedTab?.key === 'tags' &&
                        <div>
                            {allTags &&
                                <div
                                    className="design-editor-image-sidebar-container overflow-y-scroll border-gray-400 border bg-blue-50 mb-4 rounded mx-2 mt-2 shadow-xl">
                                    <SelectTags
                                        existingTags={designVariantDetail?.tagList}
                                        allTags={allTags}
                                        handleSelectTagsChanges={handleDesignVariantTagChanges}
                                        showAddTag="true"
                                        showClearSelectedTags={false}
                                        showClearSelectedTagsIcon={false}/>
                                </div>
                            }
                        </div>
                    }

                    {selectedTab?.key === 'images' &&

                        <>
                            <div
                                className="design-editor-image-sidebar-container h-full">

                                <div
                                    className="h-44 overflow-y-scroll border-gray-400 border bg-blue-50 mb-4 rounded shadow-xl">
                                    {allTags &&
                                        <SelectTags
                                            existingTags={selectedTags}
                                            allTags={allTags}
                                            handleSelectTagsChanges={handleSelectTagsChanges}
                                            showAddTag="false"
                                            showClearSelectedTags={true}
                                            showClearSelectedTagsIcon={true}/>
                                    }
                                </div>

                                <div
                                    className="design-editor-image-sidebar-container-child overflow-y-scroll border-gray-400 border bg-gray-400 rounded">
                                    <ImageSidebarSection
                                        setSelectedImage={setSelectedImage}
                                        tags={selectedTags}
                                        ignoreInitialSelection={undefined}
                                        selectedImageIdsList={_.map(designVariantDetail?.images, 'id')}
                                        refreshImages={undefined}
                                        setRefreshImages={undefined}
                                        showSelectAll={false}
                                        handleSelectAllImages={undefined}
                                        handleRemoveAllImages={undefined}/>
                                </div>

                            </div>
                        </>

                    }

                </div>

            </div>

        </>
    )
}

export default EditorSettings
